
    import './styles.scoped.css';
    export default {
  "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_xa2x2_93",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_xa2x2_102",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_xa2x2_105",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_xa2x2_108",
  "sticky-scrollbar-offset": "awsui_sticky-scrollbar-offset_faqt8_xa2x2_111",
  "is-visual-refresh": "awsui_is-visual-refresh_faqt8_xa2x2_114"
};
  